/**
 * Format: Filters
 * -----------------------------------------------------------------------------
 * Formats Shopify storefront API filters responses in collection and search.
 *
 */

/**
 * Format filters.
 * https://shopify.dev/docs/api/storefront/2024-04/connections/ProductConnection#field-productconnection-filters
 * @param {Array} filters - Filters from response.
 * @param {String} [handle] - Collection handle.
 * @returns {Array}
 */
export function formatFilters(filters, handle) {
  if (!filters || !filters.length) {
    return []
  }

  const vehicleFinderCollection =
    handle === cnvs.vehicleFinder.redirectCollection ||
    handle === cnvs.vehicleFinder.resultsCollection

  const hiddenFilters = vehicleFinderCollection
    ? cnvs.vehicleFinder.hiddenVehicleFinderFilters
    : cnvs.vehicleFinder.hiddenFilters

  return filters
    .map((filter) => {
      if (hiddenFilters.includes(filter.id)) {
        return false
      }

      const values = filter.values?.map((value) => {
        const input = JSON.parse(value.input)

        return {
          ...value,
          input,
        }
      })

      return {
        ...filter,
        values,
      }
    })
    .filter(Boolean)
}
